export default __webpack_public_path__ + "static/char-40-1a19312b7710b8298f59206820d33b57.webp";